export default {

    toggleMenuStatus(state) {
        state.isMenuOpen = !state.isMenuOpen;
    },

    showModal(state) {
        state.modalIsOpen = true;
    },

    closeModal(state) {
        state.modalIsOpen = false;
    },

    setModalHeader(state, label) {
        state.modalHeader = label;
    },

    isLoading(state, loading) {
        state.isLoading = !state.isLoading;
    },

    setApiVersion(state, version) {
        state.apiVersion = version;
    },

    setEnvType(state, type) {
        state.envType = type;
    },

    setLabel(state, payload) {
        // new lang string
        if(state.labels[payload.lang][payload.key] == undefined) {
            Object.assign(state.labels[payload.lang], { [payload.key]:  payload.value });
        }
        // update existing
        else  {
            state.labels[payload.lang][payload.key] = payload.value;
        }
    },

    setLabels(state, payload) {
        state.labels[payload.lang] = payload.labels;
    },

    setCurrentLanguage(state, lang) {
        state.currentLang = lang;
    },

    setUser(state, user) {

        // make sure we got an person object
        if(user.person == null) {
            user.person = {
                firstname: '',
                lastname: ''
            }
        }

        state.user = user;

    },


    userLogIn(state, user) {

        state.loggedIn = true;

        // make sure we got an person object
        if(user.person == null) {
            user.person = {
                firstname: '',
                lastname: ''
            }
        }

        state.user = user;

    },

    setIsExternal(state, isExternal) {

        state.isExternal = true;

    },
    /*
    setCatalogId(state, id) {
        state.catalogId = id;
    },
    */

    setCatalogData(state, catalog) {
        state.catalogData = catalog;
    },

    setEquipmentCatalogData(state, catalog) {
        state.equipmentCatalogData = catalog;
    },

    clearStorage(state) {
        state.isOldIEVersion = false;
        state.modalIsOpen = false;
        state.modalHeader = null;
        state.modalLabelFields = null;
        state.user = null;
        state.loggedIn = false;
        state.taxonomies = [];
        state.isImpersonating = false;
        state.showDownloadModal = false;
        state.industryPartnerHasCatalogPage = false;
        state.industryPartnerCatalogPages = [];
        state.currentLang = 'de';
    },

    updateCatalogPageElements(state, pageElements) {
        state.catalogPageElements = pageElements;
    },

    setTaxonomies(state, taxonomies) {

        state.taxonomiesRaw = taxonomies;

        let hashTable = {};

        taxonomies.forEach(function(taxonomy) {
            let termsHashTable = {};
            taxonomy.taxonomyTerms.forEach(function(term) {
                termsHashTable[term.name] = term;
            });
            hashTable[taxonomy.name] = termsHashTable;
        });

        state.taxonomies = hashTable;

    },

    setCatalogPagesTotal(state, pagesTotal) {
        state.catalogPagesTotal = pagesTotal;
    },

    isImpersonating(state, status) {
        state.isImpersonating = status;
    },

    showDownloadModal(state) {
        state.showDownloadModal = !state.showDownloadModal;
    },

    setDownloadURL(state, url) {
        state.downloadURL = url;
    },

    setRedirectURL(state, url) {
        state.redirectURL = url;
    },

    industryPartnerHasDoublePage(state, value) {
        state.industryPartnerHasCatalogPage = value;
    },

    industryPartnerCatalogPages(state, catalogPages) {
        state.industryPartnerCatalogPages = catalogPages;
    },

    setContentPoolFilter(state, payload) {
        if(typeof state.activeFilter.contentPool == 'undefined') {
            state.activeFilter.contentPool = {};
        }
        state.activeFilter.contentPool[payload.type] = payload.value;
    },

    setCatalogFilter(state, payload) {
        if(typeof state.activeFilter.catalog == 'undefined') {
            state.activeFilter.catalog = {};
        }
        state.activeFilter.catalog[payload.type] = payload.value;
    },

    setPharmaciesFilter(state, payload) {
        if(typeof state.activeFilter.pharmacies == 'undefined') {
            state.activeFilter.pharmacies = {};
        }
        state.activeFilter.pharmacies[payload.type] = payload.value;
    },

    setProductsFilter(state, payload) {

        if(typeof state.activeFilter.products == 'undefined') {
            state.activeFilter.products = {};
        }

        if(!state.activeFilter.products[state.user.id]) {
            state.activeFilter.products[state.user.id] = {};
        }

        state.activeFilter.products[state.user.id][payload.type] = payload.value;

    },

    setPIMFilter(state, payload) {

        state.activeFilter.pim = payload;

    },

    setCampaignsFilter(state, payload) {

        state.activeFilter.campaigns = payload;

    },

    setPIMPharmacy(state, payload) {

        state.pimPharmacy = payload;

    },

    setEquipmentsFilter(state, payload) {

        state.activeFilter.equipments[payload.type] = payload.value;

    },

    setEquipmentCatalogFilter(state, payload) {

        state.activeFilter.equipmentCatalog[payload.type] = payload.value;

    },

    setCurrentSpecialPage(state, value) {

        state.currentSpecialPage = value;

    },

    setCurrentPimTablePage(state, value) {

        state.currentPimTablePage = value;

    },

    setPimProductPageTitle(state, value) {

        state.pimProductPageTitle = value;
        
    }

}
